<template>
  <div
    class="ti-sticky-summary"
    :class="[
      { 'ti-sticky-summary--image': summary && summary.image },
      { 'ti-sticky-summary--mobile': isMobile },
    ]"
  >
    <div
      class="ti-sticky-summary__bar"
      :class="{ 'ti-sticky-summary__bar--value': residualValue }"
      v-if="isMobile"
    >
      <div class="ti-sticky-summary__bar-wrapper">
        <Transition>
          <div
            class="ti-sticky-summary__bar-background"
            v-if="showSummary"
          ></div>
        </Transition>
        <div class="ti-sticky-summary__vehicle-info">
          {{ summary.headline }}
          <span class="ti-sticky-summary__vehicle-price" v-if="residualValue">{{
            residualValue
          }}</span>
        </div>
        <button
          type="button"
          aria-label="Expand Button"
          class="wb-round-button wb-round-button--small"
          @click="toggleSummary"
        >
          <wb-icon
            class="ti-sticky-summary__expand-icon"
            name="bds/chevron-down/24"
          ></wb-icon>
        </button>
      </div>
    </div>
    <Transition>
      <div class="ti-sticky-summary__wrapper" v-show="!isMobile || showSummary">
        <img
          class="ti-sticky-summary__background"
          src="/assets/vehicle-summary-background.png"
        />

        <wb-aspect-ratio
          class="ti-sticky-summary__vehicle-image"
          ratio="16x9"
          v-if="summary.image"
        >
          <img :src="get16x9croppedImageProxySrc(summary.image, '690')" />
        </wb-aspect-ratio>

        <button
          type="button"
          aria-label="Expand Button"
          class="ti-sticky-summary__expanded-icon-button wb-round-button wb-round-button--small"
          @click="toggleSummary"
        >
          <wb-icon
            class="ti-sticky-summary__expand-icon"
            name="bds/chevron-up/24"
          ></wb-icon>
        </button>

        <div class="ti-sticky-summary__content">
          <div class="ti-sticky-summary__vehicle-image"></div>
          <div class="ti-sticky-summary__subtitle">
            {{ $t('i18n.summary.vehicle.overline') }}
          </div>
          <div class="ti-sticky-summary__headline">{{ summary.headline }}</div>
          <div class="ti-sticky-summary__copy">{{ summary.copy }}</div>
          <div class="ti-sticky-summary__vehicle-description">
            <template v-for="(section, sectionIndex) in summary.sections">
              <span v-for="(item, itemsIndex) in section.summaryItems"
                >{{ item.value }}
                {{
                  itemsIndex !== section.summaryItems.length - 1 ? '· ' : ''
                }}</span
              >
              {{ sectionIndex !== summary.sections.length - 1 ? '· ' : '' }}
            </template>
          </div>
          <div
            class="ti-sticky-summary__residual-value"
            v-if="residualValue && showResidualValue"
          >
            <div class="ti-sticky-summary__residual-value-title">
              {{
                $t(
                  'i18n.basicContactConfirmation.residualValue.feedback.headline',
                )
              }}
            </div>
            <div class="ti-sticky-summary__residual-value-price">
              {{ residualValue }}
              <ModalComponent
                :modal="$t('i18n.summary.residualValue.modal') as any"
              />
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script lang="ts" setup>
import ModalComponent from '../modal/modal.vue';
import { StepSummary } from '@tradein/api';
import { get16x9croppedImageProxySrc } from '@tradein/utils';
import { onMounted, ref } from 'vue';

interface Props {
  summary: StepSummary;
  residualValue?: string;
  isMobile: boolean;
  showResidualValue: boolean;
}

const props = defineProps<Props>();
const showSummary = ref(false);

const toggleSummary = () => {
  showSummary.value = !showSummary.value;
};
</script>
<style lang="scss" src="./sticky-summary.scss"></style>
